import React from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form } from 'reactstrap';

import { updateControlOptions } from 'jsx/components/core/form/lib/validateForm';
import { GenericModal } from 'jsx/components/core/form/components/GenericModal';
import Icon from 'jsx/components/core/icons/Icon';
import ResponseMessageTab from 'jsx/components/core/form/components/ResponseMessageTab';
import { isEmpty } from 'lodash';

export class CroppingTransactionModal extends GenericModal {
  constructor(props) {
    super(props);

    this.filterProperties = this.filterProperties.bind(this);
  }

  filterProperties(enterprise_id) {
    const { enterprises } = this.props.enterprises;
    // Only display properties that have been previously allocated to the enterprise
    const { allocations = [] } = enterprises?.rows.find(
      (enterprise) => enterprise.id === enterprise_id,
    );

    return allocations.map((allocation) => ({ ...allocation.property }));
  }

  render() {
    const { iconName, responseMessage, isOpen } = this.props;
    const { title, isNew } = this.state;
    let { controls } = this.state;

    controls = this.setOptions(controls);

    const enterprise_id = controls?.enterprise_id?.value ?? null;
    if (enterprise_id) {
      const filteredProperties = this.filterProperties(enterprise_id);
      controls = updateControlOptions(controls, 'property_id', filteredProperties);
      controls.property_id.showInEditor = filteredProperties.length > 1;

      const filteredProductTypes = this.props.filterCroppingProductTypes(enterprise_id);
      controls = updateControlOptions(controls, 'product_id', filteredProductTypes);
    }

    return (
      <Modal isOpen={isOpen}>
        <ModalHeader className="bg-corporate text-white">
          <Icon size="1x" name={iconName} className="mr-2" />
          {title}
        </ModalHeader>
        <ModalBody>
          {responseMessage && <ResponseMessageTab responseMessage={responseMessage} />}
          <Form>{!isEmpty(controls) ? this.renderInputs(controls) : null}</Form>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-center">
          <div>
            <Button
              size="sm"
              className="mr-2"
              color="success"
              onClick={() => this.onSave(controls)}
            >
              Save
            </Button>
            <Button size="sm" color="light" onClick={this.onClose}>
              Cancel
            </Button>
          </div>
          {!isNew && (
            <Button size="sm" color="danger" onClick={this.onRemove} disabled={false}>
              Delete
            </Button>
          )}
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStoreToProps = ({ attributes, direct_costs, enterprises }) => ({
  attributes,
  direct_costs,
  enterprises,
});

export default connect(mapStoreToProps)(CroppingTransactionModal);
